import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const Container = styled.div`
  display: flex;
  height: 100%;
  min-width: 100%;
  a {
    display: flex;
    width: 100%;
    height: 100%;
    overflow: hidden;
    &:hover {
      span {
        transform: scale(1.02);
      }
    }
    span {
      width: 100%;
      height: 100%;
      background-position: center;
      background-size: cover;
      transition: all 0.3s;
      display: none;

      @media (max-width: 789px) {
        &.mobile {
          display: block;
        }
      }

      @media (min-width: 789px) {
        &.desktop {
          display: block;
        }
      }
    }
  }
`;

class CarrousselItem extends Component {
  render = () => {
    const { banner, banner_mobile, link } = this.props;
    return (
      <Container>
        {
          link && (
            (link.url.match('https://guararapes.com.br/')) ? (
              <Link to={ link ? link.url.replace('https://guararapes.com.br/', '') : '' }>
                <span style={ banner && { backgroundImage: "url(" + banner.url + ")" } } class="desktop" />
                <span style={ banner_mobile && { backgroundImage: "url(" + banner_mobile.url + ")" } } class="mobile" />
              </Link>
            ) : (
              <a href={ link ? link.url : '' }  rel="noopener noreferrer" target="_blank">
                <span style={ banner && { backgroundImage: "url(" + banner.url + ")" } } />
                <span style={ banner_mobile && { backgroundImage: "url(" + banner_mobile.url + ")" } } class="mobile" />
              </a>
            )
          )
        }
      </Container>
    );
  }
}

CarrousselItem.propTypes = {
  dispatch: PropTypes.func,
  match: PropTypes.object,
  location: PropTypes.object,
};

export default CarrousselItem;
